import { render } from "./AddImageDialog.vue?vue&type=template&id=15b8287c"
import script from "./AddImageDialog.vue?vue&type=script&lang=js"
export * from "./AddImageDialog.vue?vue&type=script&lang=js"

import "./AddImageDialog.vue?vue&type=style&index=0&id=15b8287c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__